import {
    Alert,
    Box,
    Chip,
    Grid,
    LinearProgress,
    Paper,
    Typography,
} from '@mui/material';
import React, { useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { PERIOD_MONTH, planUsagePercent } from '../../helpers/planLimits';

function usageColor(entry) {
    if (entry.blocked) {
        return 'error';
    }
    return planUsagePercent(entry) >= 80 ? 'warning' : 'primary';
}

function QuotaRow({ entry }) {
    const percent = planUsagePercent(entry);
    const scope = entry.period === PERIOD_MONTH ? 'neste mês' : 'no total';

    return (
        <Grid item xs={12} sm={6} md={4}>
            <Box sx={{ mb: 0.5, display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {entry.label}
                </Typography>
                <Typography variant="caption" color={entry.blocked ? 'error.main' : 'text.secondary'}>
                    {entry.unlimited ? `${entry.used} ${scope}` : `${entry.used} de ${entry.limit} ${scope}`}
                </Typography>
            </Box>
            {entry.unlimited ? (
                <Chip label="Ilimitado" size="small" color="success" variant="outlined" />
            ) : (
                <LinearProgress
                    variant="determinate"
                    value={percent}
                    color={usageColor(entry)}
                    sx={{ height: 6, borderRadius: 3 }}
                />
            )}
        </Grid>
    );
}

/**
 * Mostra o consumo de cada cota do plano vigente. `usage` vem de /me/subscription.
 */
export default function PlanUsagePanel({ usage, showUpgradeHint = true }) {
    const entries = useMemo(() => (Array.isArray(usage) ? usage : []), [usage]);
    const blocked = useMemo(() => entries.filter((entry) => entry.blocked), [entries]);

    if (entries.length === 0) {
        return null;
    }

    return (
        <Paper variant="outlined" sx={{ p: 3, mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
                Uso do plano
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Os limites mensais reiniciam no 1º dia de cada mês. Impressoras, produtos e parceiros contam o total da conta.
            </Typography>

            {blocked.length > 0 ? (
                <Alert severity="warning" sx={{ mb: 3 }}>
                    Você atingiu o limite de {blocked.map((entry) => entry.label.toLowerCase()).join(', ')}.
                    {showUpgradeHint ? (
                        <>
                            {' '}
                            <RouterLink to="/admin/plans">Veja os planos</RouterLink> para liberar mais volume.
                        </>
                    ) : null}
                </Alert>
            ) : null}

            <Grid container spacing={3}>
                {entries.map((entry) => (
                    <QuotaRow entry={entry} key={entry.key} />
                ))}
            </Grid>
        </Paper>
    );
}
